// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import BedroomStore from "../../../../stores/BedroomStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	bedroomStore: BedroomStore;
}

@inject("bedroomStore")
@observer
export default class BedroomsTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.bedroomStore.getBedrooms(0);
	}

	public render() {
		const { bedroomStore } = this.props;
		return (
			<>
				<Table
					title={strings.bedrooms.title}
					rows={bedroomStore.bedroomsTableRows}
					header={bedroomStore.header}
					pageOffset={bedroomStore.pageOffSet}
					loading={bedroomStore.loading}
					tableIsEmptyMessage={strings.bedrooms.table.tableIsEmpty}
					prevPage={bedroomStore.previousPage}
					nextPage={bedroomStore.nextPage}
					onAddClick={() => bedroomStore.startBedroomCreateOrEdit()}
					onEditClick={(bedroomId) => bedroomStore.startBedroomCreateOrEdit(bedroomId)}
					onDeleteClick={(bedroomId, bedroomName) => bedroomStore.openDeleteBedroomDialog(bedroomId, bedroomName)}
				/>
			</>
		);
	}
}
